module.exports = __webpack_public_path__ + "static/frontUserNew/img/template-customer-address.9f7e1ad9.png";